import en from './translations/en';

export default {
  'en': en
}